import { fromJS } from 'immutable';
import { actions as integrationsActions } from 'react/api/actions/localzIntegration';

const initialState = fromJS({
  id: "Track My Appointment",
  integration: {
    name: "Track My Appointment",
  },
  isLoadingIntegration: false,
  connectionState: {
    isConnecting: false,
    success: null,
    error: null
  },
  disableState: {
    isDisabling: false,
    success: null,
    error: null
  },
  enabled: false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case integrationsActions.setConnectionState: {
      const { isConnecting, success, error } = action.payload;

      return state.set('connectionState', { isConnecting, success, error });
    }
    case integrationsActions.setIsLoadingIntegration: {
      const { isLoadingIntegration } = action.payload;

      return state.set('isLoadingIntegration', isLoadingIntegration);
    }
    case integrationsActions.updateIntegration: {
      const { integration, enabled } = action.payload;

      const integrationWithName = {
        ...integration,
        name: "Track My Appointment"
      };

      return state
        .set('integration', fromJS(integrationWithName))
        .set('enabled', enabled);
    }
    case integrationsActions.setDisableState: {
      const { isDisabling, success, error } = action.payload;

      return state.set('disableState', { isDisabling, success, error });
    }
    case integrationsActions.clearIntegrationDisableState: {
      return state.merge(initialState);
    }
    default:
      return state;
  }
}
